import React, { useEffect } from 'react';
import { Form, Input } from 'components/antd';
import { FORM_STRUCTURE } from 'AppClient/api/UserProfile';
import { PhoneInput, AlternativeContacts, ReferenceFields, FirstLastNameInputs } from 'components';
import { inject, observer } from 'mobx-react';
import { removeEmptyFromArray, hasErrors } from 'utils/utils';
import { FormComponentProps } from 'antd/lib/form';
import { isNil, isEmpty } from 'lodash-es';
import { RootStore, BookingDictionariesStore, PassengerDetailsStore } from 'AppClient/stores';
import { getOptionalLabel } from 'components/antd/Modal/TitleNotice';
import { AmendingDetails } from 'AppClient/stores/PassengerDetailsStore';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props extends FormComponentProps {
	bookingDictionariesStore?: BookingDictionariesStore;
	passengerDetailsStore?: PassengerDetailsStore;
}

const AmendPassengerDetailsForm: React.FC<Props> = props => {
	const { validateFields, getFieldDecorator } = props.form;
	useEffect(() => {
		validateFields();
	}, [validateFields]);
	const { userInfo } = props.passengerDetailsStore!;
	if (isNil(userInfo)) {
		return null;
	}
	const { countriesDictionary } = props.bookingDictionariesStore!;
	const alternativeContacts = removeEmptyFromArray(userInfo.alternativeContactList);
	const { referenceFields } = userInfo;

	return (
		<div className={classNames('modalBox modalBoxBooking', styles.AmendPassengerDetailsForm)}>
			<div className="modalBoxRow">
				<h3 className="columnPaddings">Personal details</h3>
				<div className="modalBoxCol w4">
					<FirstLastNameInputs
						form={props.form}
						firstName={userInfo.firstName}
						lastName={userInfo.lastName}
					/>
				</div>
				<div className="modalBoxCol w4">
					<Form.Item label="Phone" validateStatus={''} help={true}>
						<PhoneInput
							form={props.form}
							countries={countriesDictionary}
							initialValue={{
								phoneCodeCountryId: userInfo.phoneCodeCountryId,
								phoneNumber: userInfo.phoneNumber,
							}}
						/>
					</Form.Item>
				</div>
				<div className="modalBoxCol w4">
					<Form.Item label="Email address" validateStatus={''} help={false}>
						{getFieldDecorator(FORM_STRUCTURE.EMAIL_ADDRESS, {
							initialValue: userInfo.emailAddress,
							rules: [
								{
									required: true,
									whitespace: true,
								},
							],
						})(<Input />)}
					</Form.Item>
				</div>
			</div>
			<div className="modalBoxRow modalBoxRowNoPb">
				<h3 className="columnPaddings">{getOptionalLabel('Alternative contacts')}</h3>
			</div>
			<div className={styles.alternativeContactsWrap}>
				<AlternativeContacts
					form={props.form}
					maxRows={5}
					countriesDictionary={countriesDictionary}
					initialValues={alternativeContacts}
				/>
			</div>
			{!isEmpty(referenceFields) && (
				<>
					<h3>Reference fields</h3>
					<ReferenceFields
						form={props.form}
						valueInputName="value"
						referenceFields={referenceFields}
						numOfItemsInRow={3}
						showValidationMessage
					/>
				</>
			)}
		</div>
	);
};

const FormWrapper = Form.create<Props>({
	name: 'AmendPassengerDetailsForm',
	onFieldsChange(props: Props) {
		const { updateAmendingDetailsAndValidator } = props.passengerDetailsStore!;
		const formValues = props.form.getFieldsValue() as AmendingDetails;
		const isFieldsTouched = props.form.isFieldsTouched();
		const isValid = !hasErrors(props.form.getFieldsError());
		updateAmendingDetailsAndValidator(formValues, isValid, isFieldsTouched);
	},
})(AmendPassengerDetailsForm);

export default inject(({ bookingDictionariesStore, passengerDetailsStore }: RootStore) => ({
	bookingDictionariesStore,
	passengerDetailsStore,
}))(observer(FormWrapper));
